import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { QueryPanelContentMessage } from '../models/messages/query-panel-messages';

@Injectable({
  providedIn: 'root'
})

// Shared service for the right hand side of a isg-query-panel.
// It's used to communicate between the query panel and the content inside the
// content template.
export class QueryPanelContentConnectorService {
  /*-------------------------- private variables --------------------------*/
  private subject = new Subject<QueryPanelContentMessage>();

  /*-------------------------- public functions --------------------------*/

  public export(criteria: any, title: string, headerLines: string[]) {
    let msg = new QueryPanelContentMessage();
    msg.criteria = criteria;
    msg.headerLines = headerLines;
    msg.title = title;
    msg.type = "export";
    this.subject.next(msg);
  }

  public search(criteria: any) {
    let msg = new QueryPanelContentMessage();
    msg.criteria = criteria;
    msg.type = "search";
    this.subject.next(msg);
  }

  public onMessage(): Observable<QueryPanelContentMessage> {
    return this.subject.asObservable();
  }
}
